import { API_ADDRESS } from "@/lib/env";

export async function apiRequest<T>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    path: string,
    token: string,
    body?: unknown
): Promise<T> {
    const res = await fetch(`${API_ADDRESS}${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    let responseData: unknown;
    try {
        responseData = await res.json();
    } catch {
        responseData = null;
    }

    if (!res.ok) {
        const errData = responseData as Record<string, string> | null;
        const serverMessage = errData?.error || errData?.message || `HTTP ${res.status}`;
        // For 5xx errors, show a generic message to avoid leaking internal details
        const message = res.status >= 500
            ? 'Something went wrong. Please try again.'
            : serverMessage;
        throw new Error(message);
    }

    return responseData as T;
}
